import Event from '../domain/Event.js';

class TrackingService {

  constructor(dataLayer, trackingContext) {

    this.dataLayer = dataLayer;
    this.trackingContext = trackingContext;

  }

  submitEvent(event, metadata) {

    switch (event) {
      case Event.EMAIL_COLLECTION_FORM_VIEW:
        trackEmailCollectionFormView.bind(this)();
        break;
      case Event.EMAIL_COLLECTION_SUBMISSION:
        trackEmailCollectionSubmission.bind(this)();
        break;
      case Event.LOGIN_FORM_VIEW:
        trackLoginFormView.bind(this)();
        break;
      case Event.LOGIN:
        trackLogin.bind(this)();
        break;
      case Event.PASSWORD_RECOVERY_SUBMISSION:
        trackPasswordRecoverySubmission.bind(this)();
        break;
      case Event.ACCOUNT_CREATION:
        trackAccountCreation.bind(this)(metadata);
        break;
      case Event.FINAL_STEP_COMPLETED:
        trackFinalStepCompleted.bind(this)();
        break;
      default:
        throw new Error();
    }
  }

}

let trackEmailCollectionFormView = function () {

  this.dataLayer.push({
    'event' : 'QTQ Email Collection Form View',
    'hit.type' : 'Event',
    'hit.category' : 'QTQ',
    'hit.action' : 'Email Collection Form View',
    'interaction_description' : 'Email Collection Form View',
    'interaction_context' : this.trackingContext
  });

};

let trackEmailCollectionSubmission = function () {

  this.dataLayer.push({
    'event' : 'QTQ Email Collection Submission',
    'hit.type' : 'Event',
    'hit.category' : 'QTQ',
    'hit.action' : 'Email Collection Submission',
    'interaction_description' : 'Email Collection Submission',
    'interaction_context' : this.trackingContext
  });

};

let trackLoginFormView = function () {

  this.dataLayer.push({
    'event' : 'QTQ Login Form View',
    'hit.type' : 'Event',
    'hit.category' : 'QTQ',
    'hit.action' : 'Login Form View',
    'interaction_description' : 'Login Form View',
    'interaction_context' : this.trackingContext
  });

};

let trackLogin = function () {

  this.dataLayer.push({
    'event' : 'QTQ Login',
    'hit.type' : 'Event',
    'hit.category' : 'QTQ',
    'hit.action' : 'Login',
    'interaction_description' : 'Login',
    'interaction_context' : this.trackingContext
  });

};

let trackPasswordRecoverySubmission = function () {

  this.dataLayer.push({
    'event' : 'QTQ Password Recovery Submission',
    'hit.type' : 'Event',
    'hit.category' : 'QTQ',
    'hit.action' : 'Password Recovery Submission',
    'interaction_description' : 'Password Recovery Submission',
    'interaction_context' : this.trackingContext
  });

};

let trackAccountCreation = function (metadata) {
  
  window.ssdl = window.ssdl || {};
  window.ssdl.user = window.ssdl.user || {};
  window.ssdl.user.email = metadata.emailAddress;

  this.dataLayer.push({
    'event' : 'QTQ Account Creation',
    'hit.type' : 'Event',
    'hit.category' : 'QTQ',
    'hit.action' : 'Account Creation',
    'interaction_description' : 'Account Creation',
    'interaction_context' : this.trackingContext
  });

};

let trackFinalStepCompleted = function () {

  this.dataLayer.push({
    'event' : 'QTQ Final Step Completed',
    'hit.type' : 'Event',
    'hit.category' : 'QTQ',
    'hit.action' : 'Final Step Completed',
    'interaction_description' : 'Final Step Completed',
    'interaction_context' : this.trackingContext
  });

};

export default TrackingService;



// WEBPACK FOOTER //
// ./src/library/services/TrackingService.js